import { BaseInput } from "components/core";
import { TpaDetailInputWrapper } from "components/Flex/styles";
import { OuterBox } from "components/GhiPlanSetup/styles";
import React, { useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

const CoPay = ({formikProps}) => {
  const [referDefault, setDefault] = useState(false)
  const handleChange = () => {
    setDefault(true)
    formikProps.setFieldValue("co_pay_condition", null)
  }
  return (
    <OuterBox>
      <div style={{ marginBottom: "4rem" }}>
      <FormControlLabel
        required
        control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }} onChange={()=>handleChange()}/>}
        label={
          <span style={{ fontSize: "16px" }}>
            Please Refer Policy Document.
          </span>
        }
      />
        <TpaDetailInputWrapper marginTop="0">
          <BaseInput
            // formatToRupee
            disabled={referDefault}
            label="Co-Pay Condition"
            fontSize="16px !imortant"
            variant="standard"
            formikProps={{
              ...formikProps,
              name: "co_pay_condition",
            }}
          />
        </TpaDetailInputWrapper>
      </div>
    </OuterBox>
  );
};
export default CoPay
